import { render } from "./CampaignJourneyMenuFolders.vue?vue&type=template&id=3b18645e&scoped=true"
import script from "./CampaignJourneyMenuFolders.vue?vue&type=script&lang=js"
export * from "./CampaignJourneyMenuFolders.vue?vue&type=script&lang=js"

import "./CampaignJourneyMenuFolders.vue?vue&type=style&index=0&id=3b18645e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\adria\\OneDrive\\Escritorio\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b18645e"]])

export default __exports__